"use strict";

var LoggerInstance = require("js-logger").get("PledgeActions");

var ActionsHelper = require("../actions/ActionsHelper");

var CheckoutApi = require("../checkoutComponents/CheckoutApi");

var Spinner = require("../client/Spinner");

var ValidationHelper = require("../commonComponents/ValidationHelper");

var WizardConstants = require("../constants/WizardConstants");

var Constants = require("../designer/Constants");

var Dispatcher = require("../dispatcher/Dispatcher");

var ProjectConstants = require("../projectComponents/ProjectConstants");

var BootstrapPrompt = require("../shared/BootstrapPrompt");

var PledgeStore = require("../stores/PledgeStore");

var PledgeActions = {
	initializeStore: function (options) {
		Dispatcher.dispatch({
			actionType: Constants.PLEDGE_INITIALIZE,
			options: options
		});

		// initialize onChange for donateToday
		$(`[data-component="donateToday"]`).on("change.donateToday", (event) => {
			this.handleDonateTodayChanged(event);
		});
	},

	showSponsorshipNotAvailableMessage: function () {
		//The sponsorship is not available, so show the alert
		if (!PledgeStore.get("isSponsorshipAvailable")) {
			BootstrapPrompt.alert(PledgeStore.getWizardValue(
				WizardConstants.WIZARDS.SPONSORSHIP_DISPLAY_MESSAGES,
				WizardConstants.SPONSORSHIP_DISPLAY_MESSAGES_FIELDS.SPONSORSHIP_NOT_AVAILABLE
			));
		}
	},

	setSponsorshipAvailablity: function (isSponsorshipAvailable) {
		Dispatcher.dispatch({
			actionType: Constants.SPONSORSHIP_AVAILABLITY,
			isSponsorshipAvailable
		});
	},

	setGiftAmount: function (selectedAmount, tangibleCode, context) {
		Dispatcher.dispatch({
			actionType: Constants.PLEDGE_SET_GIFT_AMOUNT,
			context,
			selectedAmount,
			tangibleCode
		});
	},

	setMinimumAmount: function(minimumAmount, tangibleCode, context) {
		Dispatcher.dispatch({
			actionType: Constants.PLEDGE_SET_MINIMUM_AMOUNT,
			minimumAmount,
			tangibleCode,
			context
		});
	},

	setFrequency: function (selectedFrequency, pledgeCode, projectCode, context) {
		Dispatcher.dispatch({
			actionType: Constants.PLEDGE_SET_FREQUENCY,
			selectedFrequency,
			tangibleCode: pledgeCode,
			context
		});

		// Trigger an update in the project store so that the use on day and recurring upsell respond appropriately.
		var pledgeProjectOptions = {
			actionType: ProjectConstants.SET_DONATION_FREQUENCY,
			selectedFrequency,
			context
		};

		if (context) {
			pledgeProjectOptions = Object.assign(pledgeProjectOptions, {
				tangibleCode: projectCode,
				pledgeCode: pledgeCode
			});
		}

		if (this._projectDispatcher) {
			this._projectDispatcher.dispatch(pledgeProjectOptions);
		} else {
			LoggerInstance.error("Project Dispatcher not set.");
		}

		this.triggerTotalChangedHandler();
	},

	getShoppingCartData: function (cartDataOptions) {
		cartDataOptions = cartDataOptions || {};

		var {pledge, pledgeId, projectCode, amount, frequency, useOnDay, upsell, startDate} = PledgeStore.getPledgeInformation(cartDataOptions);
		var isRecurring = ($("[data-component='createRecurring.input']").prop("checked") && frequency !== "O") || PledgeStore.getRequireRecurring();
		var donateTodaySelected = $("[data-component='donateToday.input']").prop("checked") || PledgeStore.getRequireDonation();

		// Adding frequency check because we're now hiding the recurring section if frequency is one-time
		// but not unsetting values in the stores.
		return {
			pledges: [{
				amount,
				donateTodaySelected,
				frequency,
				isRecurring: isRecurring,
				pledge,
				pledgeId,
				projectCode,
				upsell: frequency !== "O" && upsell,
				useOnDay,
				startDate
			}]
		};
	},

	showRecurringUseOnDay: function(event) {
		if (PledgeStore.get("isDesignMode")) {
			return;
		}

		var $checkbox = $(event.target);
		var isChecked = $checkbox.prop("checked");
		var $wrapper = $checkbox.parent("[data-component='createRecurring']").find(".create-recurring-use-on-date");

		if (isChecked) {
			$wrapper.show();
		} else {
			$wrapper.hide();
		}

		this.triggerTotalChangedHandler();
		return false;
	},

	handleDonateTodayChanged: function (event) {
		if (PledgeStore.get("isDesignMode")) {
			return;
		}

		this.triggerTotalChangedHandler();
		return false;
	},

	addToCart: function (event, context, tangibleCode, successCallback) {
		try {
			if (!ActionsHelper.getEventOrReturn(event, PledgeStore.get("isDesignMode"), "Add To Cart called successfully.", false)) {
				return;
			}

			Spinner.showSpinner();
			var components = [];
			if (context) {
				var $parent = $(event.target).closest("[data-component='searchResults.pledge'],[data-component='category.pledge'],[data-component='carousel.pledge']");
				components = [$parent.find("[data-has-custom-validator='true']")];
			} else {
				//Validate any array that is not within a searchResults, category, or carousel component
				//The GiftArray will always be on the page, so we do not need to consider gift amount.
				var componentsToAdd = "[data-react-component-name='PledgeButtonGiftArray'],[data-react-component-name='PledgeRadioGiftArray'],[data-react-component-name='PledgeSelectGiftArray']";

				var $elements = $(componentsToAdd).filter((index, element) => {
					var $element = $(element);
					return $element.parents().length == $element.parents().not("[data-component='searchResults.pledge'],[data-component='category.pledge'],[data-component='carousel.pledge']").length;
				});
				components = [$elements];
			}

			ValidationHelper.validate({ components }).always(isValid => {
				if (!isValid) {
					Spinner.removeSpinner();
					return;
				}

				var shoppingCartData = PledgeActions.getShoppingCartData({ context, tangibleCode });
				CheckoutApi.addToCart(shoppingCartData).done((addToCartResponse) => {
					LoggerInstance.debug(addToCartResponse);

					if (addToCartResponse.success) {
						if (typeof successCallback === "function") {
							successCallback();
							Spinner.removeSpinner();
						} else {
							// See CartsController, we're determining server-side if we need to
							// navigate to the cart or not as the logic depends on several variables,
							// including logged-in state.
							// Note that adding a pledge to the cart is not currently supported; if
							// support is added in the future, however, consideration will need to be
							// given to the confirmation page override feature
							if (addToCartResponse.message === "orderconfirmation") {
								window.location = "/orderconfirmation";
							} else {
								window.location = "/shoppingcart";
							}
						}
					} else if (addToCartResponse.message) {
						//This should be a constituent-safe message
						BootstrapPrompt.alert(addToCartResponse.message);
						Spinner.removeSpinner();
					} else {
						BootstrapPrompt.alert(PledgeStore.getWizardValue(
							WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
							WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
							{ tangibleType: "pledge" }
						));
						Spinner.removeSpinner();
					}
				}).fail(() => {
					BootstrapPrompt.alert(PledgeStore.getWizardValue(
						WizardConstants.WIZARDS.SHOPPING_CART_MESSAGES,
						WizardConstants.SHOPPING_CART_MESSAGE_FIELDS.ADD_TO_CART_ERROR,
						{ tangibleType: "pledge" }
					));
					Spinner.removeSpinner();
				});
			});
		} catch (exception) {
			LoggerInstance.error(exception);
		} finally {
			return false;
		}
	},

	/**
	 * This method is called by checkout store to determine if we should be updating payment information.
	 */
	shouldHidePaymentInformation: function () {
		var { upsell, frequency } = PledgeStore.getPledgeInformation();
		var isRecurring = ($("[data-component='createRecurring.input']").prop("checked") && frequency !== "O") || PledgeStore.getRequireRecurring();
		var donateTodaySelected = $("[data-component='donateToday.input']").prop("checked") || PledgeStore.getRequireDonation();

		return {
			hideOneTimeOnlyPayments: isRecurring,
			hideAllPayments: !isRecurring && !donateTodaySelected && !upsell
		};
	},

	/**
	 * This method is called when checkout store initializes. It provides a callback method to be used when
	 * this tangible's concept of a total amount has changed. This will let checkout store determine if
	 * payment information should be hidden - in conjunction with shouldHidePaymentInformation().
	 * @param handleTotalChange the callback method to trigger a total amount update.
	 */
	setChangeHandlerMethod: function (handleTotalChange) {
		this._handleTotalChange = handleTotalChange;
	},

	triggerTotalChangedHandler: function () {
		if (_.isFunction(this._handleTotalChange)) {
			this._handleTotalChange();
		}
	},

	setProjectDispatcher: function (projectDispatcher) {
		this._projectDispatcher = projectDispatcher;
	}
};

module.exports = PledgeActions;



// WEBPACK FOOTER //
// ./Javascript/actions/PledgeActions.jsx